import AdminIndex from "@/views/admin/AdminIndex.vue";

const admin = [
    {
        path: '/admin',
        name: 'admin',
        component: AdminIndex,
        meta: {
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    }
]

export default admin;